import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 166 78",
  "content": "<symbol viewBox=\"0 0 166 78\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cross\">\n<path d=\"M1.33594 75.209L165.336 1.20899\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M1.33594 1.20898L165.336 77.2231\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol